<div class="d-flex flex-column justify-content-between flex-fill px-3 mb-1">
  <div class="row">
    <div class="content-box">
      <shrd-pf-ui-header-user-info-button
        [userAccount]="userAccount"
        [omitUserTitle]="omitUserTitle"
        [accountIsSelectable]="false"
      ></shrd-pf-ui-header-user-info-button>
    </div>
  </div>
  <div class="row" *ngIf="!showAccountList; else backButton">
    <div *ngIf="canSwitchAccount" class="content-box content-box-tertiary-left ms-2 ms-md-0">
      <button shrdUicButton variant="tertiary" class="m-0" (click)="onToggleAccountSelection(true)">
        <shrd-uic-svg-icon [icon]="iconSet.ARROW_RIGHT" size="small"></shrd-uic-svg-icon>
        <span>{{ 'header.account.switchAccount' | i18next }}</span>
      </button>
    </div>
    <div class="content-box content-box-tertiary-left ms-2 ms-md-0">
      <shrd-pf-ft-header-user-logout buttonClasses="m-0" buttonVariant="tertiary" [logoutConfig]="logoutConfig">
        <shrd-uic-svg-icon [icon]="iconSet.ARROW_RIGHT" size="small"></shrd-uic-svg-icon>
        <span>{{ 'header.account.logout' | i18next }}</span>
      </shrd-pf-ft-header-user-logout>
    </div>
  </div>
</div>

<ng-template #backButton>
  <button shrdUicButton variant="tertiary" class="m-0" (click)="onToggleAccountSelection(false)">
    <shrd-uic-svg-icon [icon]="iconSet.ARROW_LEFT"></shrd-uic-svg-icon>
    <span>{{ 'common.label.button.back' | i18next }}</span>
  </button>
</ng-template>
